var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220.003,
    height: 38.007,
    viewBox: "0 0 220.003 38.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-20.023 -129.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_5537",
    "data-name": "\\u7EC4 5537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_399",
    "data-name": "\\u7EC4 399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_256",
    "data-name": "\\u8DEF\\u5F84 256",
    d: "M76.757,161.742l2.094-2.873.016-4.012H68.5l-.009-2.747H78.855l.024-1.34,6.193-2.341-.02-.718H70.989v-2.745h21.1v3.513l-7.971,3.065-.021.566h9.852l.01,2.747H84.017v4.837a2.187,2.187,0,0,1-.561,1.477,1.767,1.767,0,0,1-1.358.576Zm11.756-18.2.022-1.922H74.112l-.021,1.922H68.5v-4.676h1.993l-.642-2.784h5.542l.645,2.784H78.54l-.61-2.784h5.536l.613,2.784h2.374l.634-2.784h5.537l-.632,2.784h1.957v4.67Z",
    fill: "#353b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_400",
    "data-name": "\\u7EC4 400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_257",
    "data-name": "\\u8DEF\\u5F84 257",
    d: "M100.169,161.705l.032-24.517-.651-1.059h4.28l-.034,25.576Zm17.215-.071,1.069-1.526-.034-1.736h-5.655l.014,3.262h-4.573l-.019-12.973H123l.009,10.921a2.843,2.843,0,0,1-.361,1.531,1.179,1.179,0,0,1-1.1.521Zm-4.636-4.975H118.4l.028-2.165h-5.669Zm.013-3.851h5.661v-2.022h-5.658Zm-15.968,1.648.506-13.017h1.935l-.351,13.009Zm8.07-6.23-.149-6.779h1.935l.23,6.779Zm2.8-1.1-.017-1.974h5.432l-.027-1.907h-4.384v-1.839h4.385l.027-1.9h-5l-.012-2.014h5.023l.024-.945-.332-.412h4.979l-.026,1.357h5.176l.014,2.014h-5.16l-.027,1.9h4.548v1.833h-4.558l.031,1.907h5.816l.012,1.975Z",
    fill: "#353b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_404",
    "data-name": "\\u7EC4 404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_261",
    "data-name": "\\u8DEF\\u5F84 261",
    d: "M142.438,161.741l2.148-2.909-.022-8.487h-7.413l-4.324,11.4h-5.5l4.324-11.4h-3.238l.014-2.784h21.708v12.128a2.056,2.056,0,0,1-.547,1.459,1.786,1.786,0,0,1-1.37.593Zm4.475-15.939-5.777-9.711h5.427l5.776,9.711Zm-20.689,0,5.5-9.279-.373-.432h6.073l-5.776,9.711Z",
    fill: "#353b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_405",
    "data-name": "\\u7EC4 405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_262",
    "data-name": "\\u8DEF\\u5F84 262",
    d: "M158.681,161.717l-.013-18.616H155.2l-.009-2.748h3.5V136.7l-.445-.557h4.311v4.214h3.36l.009,2.748H162.54l.013,18.616Zm16.7-.039V148.155h-2.934l-.427,13.519h-5.1l.824-23.569,13.452-1.986v2.917l-8.459,1.063-.2,5.312h9.237l-.015,2.744h-1.9v13.519ZM155.323,159.5l.529-14.833h1.976L157.3,159.5Zm8.459-.638-.5-14.184h2.08l.5,14.184Z",
    fill: "#353b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_406",
    "data-name": "\\u7EC4 406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_263",
    "data-name": "\\u8DEF\\u5F84 263",
    d: "M192.757,161.755l2.121-2.91.026-7.1h-8.7l-.009-2.917,4.959-3.643H186.2l.012-3.242,3.117-2.231-4.374.183v-3.1l25.447-.714-.016,2.75-14.327.615-3.13,2.6h16.218v3.187H196.454l-4.8,3.775H204l-.311-1.428h5.54l1.066,4.872h-5.54l-.148-.7h-4.156v7.952a2.15,2.15,0,0,1-.559,1.477,1.774,1.774,0,0,1-1.358.576Zm13.18-1.319-2.773-6.234h4.86l2.769,6.229Zm-21.418,0,2.789-6.229h4.827l-2.758,6.229Z",
    fill: "#353b47"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_264",
    "data-name": "\\u8DEF\\u5F84 264",
    d: "M213.964,158.8l8.648-.642.009,2.743-8.682.576Zm18.011,3.179V151.164H236.3v7.362h2.95l.769-.87.009,4.315Zm-8-.238,1.737-10.577h4.3l-1.736,10.577ZM213.968,156l-.011-3.029,2.374-5.325H213.97v-3.029l3.354-7.6-.419-.482h5.525L218.7,144.9h3.727l-3.726,8.346h3.931l.009,2.747Zm22.276-6.259-.22-.674-12.111.655-.009-3.008,2.671-6.024h-3.3l.017-2.75h5.227l.02-1.208-.77-.878h6.344l-.034,2.086h5.343l-.018,2.75h-7.34l-2.655,5.96,5.828-.31-.624-2.139h3.661l1.646,5.533Z",
    fill: "#353b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_398",
    "data-name": "\\u7EC4 398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_256-2",
    "data-name": "\\u8DEF\\u5F84 256-2",
    d: "M34.753,164.524H21.363a1.743,1.743,0,0,0-1.293,2.1v0a1.741,1.741,0,0,0,1.292,1.3H59.222a1.746,1.746,0,0,0,0-3.395Z",
    fill: "#22a888"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_397",
    "data-name": "\\u7EC4 397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62_169",
    "data-name": "\\u77E9\\u5F62 169",
    d: "M52.464,140.774h0a4.74,4.74,0,0,1,4.732,4.748v10.859a4.741,4.741,0,0,1-4.732,4.75h0a4.741,4.741,0,0,1-4.732-4.75V145.524a4.74,4.74,0,0,1,4.731-4.75Z",
    fill: "#21c2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62_170",
    "data-name": "\\u77E9\\u5F62 170",
    d: "M28.127,137.088h0a4.74,4.74,0,0,1,4.732,4.748v14.545a4.741,4.741,0,0,1-4.732,4.75h0a4.743,4.743,0,0,1-4.733-4.75V141.838a4.742,4.742,0,0,1,4.732-4.75Z",
    fill: "#fac92b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62_171",
    "data-name": "\\u77E9\\u5F62 171",
    d: "M40.295,129.917h0a4.74,4.74,0,0,1,4.732,4.748v21.716a4.741,4.741,0,0,1-4.732,4.75h0a4.742,4.742,0,0,1-4.733-4.75h0V134.667a4.741,4.741,0,0,1,4.732-4.75Z",
    fill: "#22a888"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.88d17098e9937daf7844692ec5f3fdce.svg";
export { ForwardRef as ReactComponent };